import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_API_URL;
// or whatever variable you already use for your API URL

export const socket = io(SOCKET_URL, {
    autoConnect: false,
    transports: ['websocket'],
});

export default socket;